<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="query-form">
      <el-form label-position="right" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="用户ID">
                  <el-input v-model="queryForm.appUserId" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="拿货渠道">
                  <el-select v-model="queryForm.goodsChannel" clearable style="width: 100%" placeholder="请选择">
                    <el-option v-for="item in channelList" :key="item.dataDictionaryValue" :label="item.dictName" :value="item.dataDictionaryValue"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="现有卖货渠道">
                  <el-select v-model="queryForm.sellGoodsChannel" clearable style="width: 100%" placeholder="请选择">
                    <el-option v-for="item in sellChannelList" :key="item.dataDictionaryValue" :label="item.dictName" :value="item.dataDictionaryValue"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="货品所在地">
                  <el-select v-model="queryForm.goodsLocation" clearable style="width: 100%" placeholder="请选择">
                    <el-option v-for="item in locationList" :key="item.dataDictionaryValue" :label="item.dictName" :value="item.dataDictionaryValue"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="货品品牌">
                  <el-input v-model="queryForm.existProductBrand" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="微信号">
                  <el-input v-model="queryForm.wechatNumber" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="状态">
                  <el-select v-model="queryForm.status" clearable style="width: 100%" placeholder="请选择">
                    <el-option label="未处理" :value="1"></el-option>
                    <el-option label="已处理" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="申请时间">
                  <el-date-picker
                    style="width:100%"
                    v-model="daterange"
                    type="daterange"
                    value-format="timestamp"
                    :editable="false"
                    :default-time="['00:00:00', '23:59:59']"
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="tr">
      <el-button type="primary" @click="exportExcel">导出</el-button>
    </div>
    <el-table :data="tableData">
      <el-table-column prop="sellerApplyRecordId" label="ID"></el-table-column>
      <el-table-column prop="appUserId" label="用户ID"></el-table-column>
      <el-table-column prop="goodsChannel" label="拿货渠道"></el-table-column>
      <el-table-column prop="sellGoodsChannel" label="现有卖货渠道"></el-table-column>
      <el-table-column prop="goodsLocation" label="现有货品所在地"></el-table-column>
      <el-table-column prop="existProductBrand" label="现有货品品牌"></el-table-column>
      <el-table-column prop="wechatNumber" label="微信"></el-table-column>
      <el-table-column prop="otherContactWay" label="其他联系方式"></el-table-column>
      <el-table-column prop="remark" label="备注"></el-table-column>
      <el-table-column prop="statusStr" label="状态"></el-table-column>
      <el-table-column prop="createdAt" label="申请时间"></el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.statusStr === '未处理'" @click="updateItem(scope.row)">标记已处理</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNum"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
import { downloadUrlFile } from '@/utils/functions';
import {
  getSellerApplyList,
  exportSellerApply,
  updateSellerApplyStatus,
  getDictByCode,
} from "./api";

export default {
  data() {
    return {
      fullscreenLoading: false,
      daterange: [],
      queryForm: {
        appUserId: null,
        goodsChannel: null,
        sellGoodsChannel: null,
        goodsLocation: null,
        existProductBrand: null,
        wechatNumber: null,
        pageNum: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
      options: [],
      channelList: [],
      sellChannelList: [],
      locationList: [],
    };
  },
  mounted() {
    getDictByCode({ dictCode: 'goods_channel' }).then(res => {
      this.channelList = res.data.data || [];
    })
    getDictByCode({ dictCode: 'sell_goods_channel' }).then(res => {
      this.sellChannelList = res.data.data || [];
    })
    getDictByCode({ dictCode: 'goods_location' }).then(res => {
      this.locationList = res.data.data || [];
    })
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNum = 1;
      this.getTableData();
    },
    reset() {
      this.daterange = [];
      this.queryForm.appUserId = null;
      this.queryForm.goodsChannel = null;
      this.queryForm.sellGoodsChannel = null;
      this.queryForm.goodsLocation = null;
      this.queryForm.existProductBrand = null;
      this.queryForm.wechatNumber = null;
      this.queryForm.pageNum = 1;
      this.getTableData();
    },
    getTableData() {
      getSellerApplyList({
        ...this.queryForm,
        startTimestamp: this.daterange ? this.daterange[0] : null,
        endTimestamp: this.daterange ? this.daterange[1] : null,
      }).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list;
        }
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNum) {
      this.queryForm.pageNum = pageNum;
      this.getTableData();
    },
    updateItem(row) {
      updateSellerApplyStatus({
        sellerApplyRecordId: row.sellerApplyRecordId
      }).then((res) => {
        if (res.data && res.data.success) {
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
          this.getTableData();
        } else {
          this.$message.error(res.data.data || res.data.message);
        }
      })
    },
    exportExcel() {
      this.fullscreenLoading = true;
      exportSellerApply({
        ...this.queryForm,
        startTimestamp: this.daterange ? this.daterange[0] : null,
        endTimestamp: this.daterange ? this.daterange[1] : null,
      }).then(res => {
        if (res.data && res.data.data && res.data.data.ossUrl) {
          downloadUrlFile(res.data.data.ossUrl);
        }
        this.fullscreenLoading = false;
      }).catch(() => {
        this.$message.error('系统异常');
        this.fullscreenLoading = false;
      })
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
</style>
